import React, { useState } from 'react'
import {useHistory } from 'react-router-dom';
import { useRef } from "react";
import {
    PageTitleText,FormContainer,PageLinkText,AuthBgContainer,FlexContainer,PageLinkTextNoLink 
} from './sign_up.style';

import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn
} from '../../../widget/styledComponents/input_field.style'
import { gql, useMutation } from '@apollo/client';
import AppLogo from '../../../widget/app_logo';
import { toaster } from 'evergreen-ui';


export const AUTH_SIGN_UP = gql`
mutation FacilityManager_signup($name: String!, $email: String!, $phone: String!, $password: String!) {
  facilityManager_signup(name: $name, email: $email, phone: $phone, password: $password) {
    code
    success
    error
    token
  }
}
`;




function SignUpWidget() {
const history = useHistory()
const [signUpFacilityManager, { loading }] = useMutation(AUTH_SIGN_UP);

const handleSubmit=(e)=>{
e.preventDefault()
    console.log("clckccy")
    signUpFacilityManager({
        variables: { 
            name:nameRef.current.value,
            email: emailRef.current.value,
            phone:phoneRef.current.value,
            password: passwordRef.current.value,
        },
    })
    .then((response) => {
        const data = {token: response.data['facilityManager_signup']['token'] };
        toaster.success("Enter verification code down below")
        history.push(`/signUpActivateAccount/${data.token}`);
    })
    .catch((error) => {
        toaster.danger(error.message)
    });
}
const nameRef = useRef(null);
const emailRef = useRef(null);
const phoneRef = useRef(null);
const passwordRef = useRef(null);

const [showPass,setShowPass] = useState(false)

  return (
    <div className='row'>
        <AuthBgContainer className="col s12 m6 l6 hide-on-med-and-down"></AuthBgContainer>
        <div className='col s12 m6 l6 '>
            <div className='mt-100'></div>
            <form onSubmit={handleSubmit}>
            <FormContainer >
                <div className='right'>
                    <AppLogo/>
                </div>
                <br/><br/>
                <PageTitleText>
                    <small>Create Account</small>
                </PageTitleText>
                <br/>
                <InputFieldTitleText>
                    Full Name
                </InputFieldTitleText>
                <AppInputField
                    type="text" 
                    placholder="Jane Doe"
                    ref={nameRef}
                    required
                /> 
                <InputFieldTitleText>
                    Email Address
                </InputFieldTitleText>
                <AppInputField
                    type="email" 
                    placholder="alijames@gmail.com"
                    ref={emailRef}
                    required
                /> 
                <InputFieldTitleText>
                    Phone No.
                </InputFieldTitleText>
                <AppInputField
                    type="tel" 
                    placholder="090-000-000-000"
                    ref={phoneRef}
                    required
                /> 
                <InputFieldTitleText>
                    Password
                </InputFieldTitleText>
                <AppInputField
                    type= {showPass?'text':'password' }
                    ref={passwordRef}
                    required
                /> 
                <div className='row '>
                    <div className='col s12 right'>
                        <PageLinkTextNoLink className='right' style={{
                        color:"var(--black, #4F46E5) !important",fontSize:"12px",
                        }} onClick={()=>setShowPass(!showPass)}>{showPass?'Hide':'Show'}</PageLinkTextNoLink >
                    </div>
                </div>
                <AppInputFieldBtn className="mt-50" 
                    type="submit"
                     disabled={loading} 
                >
                  {!loading && 'Sign Up' } 
                  {loading && 'Loading' } 
                </AppInputFieldBtn>
                <FlexContainer>
                    Already have an account?
                    <PageLinkText className='right' style={{
                        color:"var(--black, #4F46E5) !important",fontSize:"18px",
                    }} to="/" > Log in</PageLinkText>
                </FlexContainer>
                

            </FormContainer>
            </form>

        </div>
    </div>
  )
}

export default SignUpWidget